import { Button, Stack } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { loginUser } from "../../../redux/slices/userSlice";
import { useNavigate } from "react-router-dom";

function TopMenu(props) {
    const navigate = useNavigate();

    const loginUserDetail = useSelector(loginUser);
    const user = loginUserDetail?.user || [];
    const userPermissions = useSelector((state) => state.user.permission);
    const userAccessModule = useSelector((state) => state.user.moduleAccess);

    return (

        <>
            {
                props?.page === 'overview' &&
                <Stack spacing={0.5} direction={'row'} className="page-tabs">
                    <Button variant="contained" color="secondary" size='small'>Overview</Button>
                    {
                        user?.real_time_location_traking === 'yes' &&
                        <Button variant="text" size='small' onClick={e => { navigate('/reports/track-users'); }}>Track Users</Button>
                    }
                    {
                        user?.lead_location_traking === 'yes' && (userPermissions?.includes("visitlog_list")) &&
                        <Button variant="text" size='small' onClick={e => { navigate('/reports/visit-log-activities'); }}>Visit Log Activities</Button>
                    }
                    {
                        (userAccessModule?.includes("quote") && userPermissions?.includes("quote_list")) &&
                        <Button variant="text" size='small' onClick={e => { navigate('/reports/sales-quota'); }}>Sales Quota</Button>
                    }
                </Stack>
            }

            {
                props?.page === 'track' &&
                <Stack spacing={0.5} direction={'row'} className="page-tabs">
                    <Button variant="text" size='small' onClick={() => navigate('/reports')}>Overview</Button>
                    {
                        user?.real_time_location_traking === 'yes' &&
                        <Button variant="contained" color="secondary" size='small'>Track Users</Button>
                    }
                    {
                        user?.lead_location_traking === 'yes' && (userPermissions?.includes("visitlog_list")) &&
                        <Button variant="text" size='small' onClick={() => navigate('/reports/visit-log-activities')}>Visit Log Activities</Button>
                    }
                    {
                        (userAccessModule?.includes("quote") && userPermissions?.includes("quote_list")) &&
                        <Button variant="text" size='small' onClick={e => { navigate('/reports/sales-quota'); }}>Sales Quota</Button>
                    }
                </Stack>
            }

            {
                props?.page === 'activity' &&
                <Stack spacing={0.5} direction={'row'} className="page-tabs">
                    <Button variant="text" size='small' onClick={e => { navigate('/reports'); }}>Overview</Button>
                    {
                        user?.real_time_location_traking === 'yes' &&
                        <Button variant="text" size='small' onClick={e => { navigate('/reports/track-users'); }}>Track Users</Button>
                    }
                    {
                        user?.lead_location_traking === 'yes' && (userPermissions?.includes("visitlog_list")) &&
                        <Button variant="contained" color="secondary" size='small'>Visit Log Activities</Button>
                    }
                    {
                        (userAccessModule?.includes("quote") && userPermissions?.includes("quote_list")) &&
                        <Button variant="text" size='small' onClick={e => { navigate('/reports/sales-quota'); }}>Sales Quota</Button>
                    }
                </Stack>
            }

            {
                props?.page === 'sales-quota' &&
                <Stack spacing={0.5} direction={'row'} className="page-tabs">
                    <Button variant="text" size='small' onClick={e => { navigate('/reports'); }}>Overview</Button>
                    {
                        user?.real_time_location_traking === 'yes' &&
                        <Button variant="text" size='small' onClick={e => { navigate('/reports/track-users'); }}>Track Users</Button>
                    }
                    {
                        user?.lead_location_traking === 'yes' && (userPermissions?.includes("visitlog_list")) &&
                        <Button variant="text" size='small' onClick={() => navigate('/reports/visit-log-activities')}>Visit Log Activities</Button>
                    }
                    {
                        (userAccessModule?.includes("quote") && userPermissions?.includes("quote_list")) &&
                        <Button variant="contained" size='small' color="secondary" onClick={e => { navigate('/reports/sales-quota'); }}>Sales Quota</Button>
                    }
                </Stack>
            }
        </>
    );
}

export default TopMenu;